import React from 'react'

const YouTube = ({ className, height, id, src, style, title, width, ...props }) => (
  <iframe
    id={id || `youtube-player`}
    className={`youtube ${className || ''}`.trim()}
    height={height || 405}
    src={`${src}`}
    frameBorder={`0`}
    allow={`accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture`}
    allowFullScreen
    origin={`getroute.com`}
    referrerPolicy={`no-referrer-when-downgrade`}
    style={style}
    title={title}
    width={width || 720}
    {...props}
  />
)

// const YouTube = ({ className, height, src, style, title, width }) => {
//   let player
//   let tag
//   let firstScriptTag

//   if (window && window.document) {
//     tag = window.document.createElement('script')
//     tag.id = 'yt-iframe'
//     tag.src = 'https://www.youtube.com/iframe_api'

//     firstScriptTag = window.document.getElementsByTagName('script')[0]
//     firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
//   }

//   function onYouTubeIframeAPIReady() {
//     let YT
//     if (window.YT) {
//       YT = window.YT
//     }

//     if (YT) {
//       player = new YT.Player('video-player', {
//         onReady: onPlayerReady,
//         onStateChange: onPlayerStateChange
//       })

//       let ytAnalytics = new window.analyticsPlugins.YT(
//         player,
//         'XXXXXXXXXXXXXXXXXXXXXXXXXXXX0365'
//       )
//       ytAnalytics.initialize()
//     }
//   }

//   function onPlayerReady(event) {
//     event.target.playVideo()
//   }

//   let done = false
//   function onPlayerStateChange(event) {
//     let YT
//     if (window.YT) {
//       YT = window.YT
//     }

//     if (YT && event.data === YT.PlayerState.PLAYING && !done) {
//       setTimeout(stopVideo, 6000)
//       done = true
//     }
//   }

//   function stopVideo() {
//     player.stopVideo()
//   }

//   return (
//     <>
//       <iframe
//         id={`video-player`}
//         className={`youtube ${className || ''}`}
//         height={height || 390}
//         src={`${src}?enablejsapi=1`}
//         frameBorder="0"
//         allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
//         allowFullScreen
//         origin={`getroute.com`}
//         style={style}
//         title={title}
//         width={width || 640}
//       />
//       {player}
//       {onYouTubeIframeAPIReady()}
//     </>
//   )
// }

export default YouTube
